/**
 * Datos del reporte que se generara de las tareas
 *
 * @class DatosReporte
 */
export class DatosReporteTarea {
  fecha_creacion: string;
  fecha_finalizacion: string;
  tarea: string;
  tramite: string;
}

/**
 * Datos del reporte que se generara de los tramites
 *
 * @class DatosReporte
 */
export class DatosReporte {
  fecha_creacion: string;
  fecha_finalizacion: string;
  tramite: number;
}

/**
 * Modelo de un reporte dinamicos
 *
 * @export
 * @class ReporteDinamico
 */
export class ReporteDinamico {
  id: number;
  nombre: string;
  fecha_registro: string;
  tipo_reporte: TipoReporte;
}

/**
 * Modelo del tipo de reporte dinamico
 *
 * @export
 * @class TipoReporte
 */
export class TipoReporte {
  id: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo de la consulta de los reportes
 *
 * @export
 * @class Reporte
 */
export class Reporte {
  id?: number;
  nombre: string;
  descripcion: string;
  codigo: string;
  tipo_reporte: number | TipoReporte;
  categoria: number;
}

/**
 * Modelo de la categoria del reporte
 *
 * @export
 * @class CategoriaReporte
 */
export class CategoriaReporte {
  id?: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo de la consulta de reportes por categoria
 *
 * @export
 * @class ReportesCategoria
 * @extends {CategoriaReporte}
 */
export class ReportesCategoria extends CategoriaReporte {
  reportes: Reporte[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/reporte.model.ts